import { severity } from "@/api/mutation/useOrganisationMutation";
// import { ImpactEnumSchema, ProbabilityEnumSchema } from "@backend/src/schemas/enums";

export const getSeverityAndColor = (
  impact: number,
  probability: number,
  severityTypes: severity[]
) => {
  const conditionsColor = ["#fef08acc","#facc15cc", "#ef444480"];
  
  const num = (impact + 1) * (probability + 1);
  const value = severityTypes?.sort((a, b) => a.min - b.min);
  const condition = value?.find(({ min, max }) => {
    return num >= min && num <= (max == -1 ? Infinity : max);
  });

  const index = value?.findIndex((t) => t.severityId == condition?.severityId);

  const returnData = {color:conditionsColor[index ?? 0] ?? "#fff",severity:condition?.type.toUpperCase().replace(" ", "_")};
  return returnData;
};
 